import React from "react";
import { usePayablePDF, PayablePDFFrame } from "./PayablePDF2";
import { useLocation } from "react-router-dom";

const PDFViewerPage = () => {
  // Get the ID from URL query parameters
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const payablePdf = usePayablePDF(id);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 9999,
        background: "white",
      }}
    >
      <PayablePDFFrame
        url={payablePdf.url}
        error={payablePdf.error}
        height="100%"
      />
    </div>
  );
};

export default PDFViewerPage;
